import { CommonModule, DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-edit-import-data-row-dialog',
  templateUrl: './edit-import-data-row-dialog.component.html',
  styleUrls: ['./edit-import-data-row-dialog.component.scss'],
  providers: [ DatePipe ],
  standalone: true,
  imports: [
    MatProgressSpinner,
    MatFormFieldModule,
    ReactiveFormsModule,
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatIcon,
    MatDialogModule,
    MatDatepickerModule
  ]
})
export class EditImportDataRowDialogComponent implements OnInit {

  loading = new BehaviorSubject<boolean>(false);
  editImportDataForm!: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EditImportDataRowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.editImportDataForm = this.formBuilder.group({
      reservation_reference_id: this.data["Booking ID"],
      policy_id: this.data["Policy ID"],
      arrival_date: this.data["Accommodation Start Date"],
      departure_date: this.data["Accommodation End Date"],
      booking_date: this.data["Reported"],
      reservation_cost: this.data["Total Charge"],
      guest: this.data["Guest's Name"],
      owner: this.data["Owners Name"],
      property_reference_id: this.data["Unit ID"],
      property_name: this.data["Property Name"],
      property_address: this.data["Property Address"],
      city: this.data["City"],
      state: this.data["State"],
      postal_code: this.data["Postal Code"]
    });
  }

  onSaveChangesClick() {
    this.updateData();
    this.dialogRef.close(this.data);
  }

  updateData() {
    this.data["Booking ID"] = this.editImportDataForm.get('reservation_reference_id')?.value;
    this.data["Policy ID"] = this.editImportDataForm.get('policy_id')?.value;
    this.data["Accommodation Start Date"] = this.editImportDataForm.get('arrival_date')?.value;
    this.data["Accommodation End Date"] = this.editImportDataForm.get('departure_date')?.value;
    this.data["Total Charge"] = this.editImportDataForm.get('reservation_cost')?.value;
    this.data["Guest's Name"] = this.editImportDataForm.get('guest')?.value;
    this.data["Owners Name"] = this.editImportDataForm.get('owner')?.value;
    this.data["Unit ID"] = this.editImportDataForm.get('property_reference_id')?.value;
    this.data["Property Name"] = this.editImportDataForm.get('property_name')?.value;
    this.data["Property Address"] = this.editImportDataForm.get('property_address')?.value;
    this.data["City"] = this.editImportDataForm.get('city')?.value;
    this.data["State"] = this.editImportDataForm.get('state')?.value;
    this.data["Postal Code"] = this.editImportDataForm.get('postal_code')?.value;
    this.data["Reported"] = this.editImportDataForm.get('booking_date')?.value;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  get arrivalDateValue(): Date | null {
    const value = this.editImportDataForm.get('arrival_date')?.value;
    return value ? new Date(value) : null;
  }

  get departureDateValue(): Date | null {
    const value = this.editImportDataForm.get('departure_date')?.value;
    return value ? new Date(value) : null;
  }
}